import React from 'react';
import { esFechaIsoCompleta, toYmd } from '../utils/pagoJornalPlanilla';

const pad2 = (n) => String(n).padStart(2, '0');

function partesFecha(valor) {
  if (!esFechaIsoCompleta(valor)) return { y: '', m: '', d: '' };
  const [y, m, d] = String(valor).split('T')[0].split('-');
  return { y, m, d };
}

export default function FechaDesdeMixtoSelect({
  value,
  min,
  max,
  disabled = false,
  onCommit,
}) {
  const { y, m, d } = partesFecha(value);
  const minIso = toYmd(min) || '2020-01-01';
  const maxIso = toYmd(max) || '2035-12-31';
  const yearStart = Number(minIso.slice(0, 4));
  const yearEnd = Number(maxIso.slice(0, 4));
  const years = [];
  for (let year = yearStart; year <= yearEnd; year += 1) years.push(year);

  const yearNum = Number(y) || yearStart;
  const monthNum = Number(m) || Number(minIso.slice(5, 7));
  const daysInMonth = new Date(yearNum, monthNum, 0).getDate();

  const emitir = (nextY, nextM, nextD) => {
    if (!nextY || !nextM || !nextD) return;
    const last = new Date(Number(nextY), Number(nextM), 0).getDate();
    const day = Math.min(Number(nextD), last);
    const iso = `${nextY}-${pad2(nextM)}-${pad2(day)}`;
    if (!esFechaIsoCompleta(iso)) return;
    const clipped = iso < minIso ? minIso : (iso > maxIso ? maxIso : iso);
    if (clipped !== value) onCommit(clipped);
  };

  return (
    <div className="flex items-center gap-1">
      <select
        aria-label="Día"
        className="border border-gray-300 rounded-lg px-2 py-2 bg-white"
        value={d}
        disabled={disabled}
        onChange={(e) => emitir(y || yearStart, m || pad2(monthNum), e.target.value)}
      >
        <option value="">Día</option>
        {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => (
          <option key={day} value={pad2(day)}>{pad2(day)}</option>
        ))}
      </select>
      <select
        aria-label="Mes"
        className="border border-gray-300 rounded-lg px-2 py-2 bg-white"
        value={m}
        disabled={disabled}
        onChange={(e) => emitir(y || yearStart, e.target.value, d || '01')}
      >
        <option value="">Mes</option>
        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
          <option key={month} value={pad2(month)}>{pad2(month)}</option>
        ))}
      </select>
      <select
        aria-label="Año"
        className="border border-gray-300 rounded-lg px-2 py-2 bg-white min-w-[5.5rem]"
        value={y}
        disabled={disabled}
        onChange={(e) => emitir(e.target.value, m || pad2(monthNum), d || '01')}
      >
        <option value="">Año</option>
        {years.map((year) => (
          <option key={year} value={String(year)}>{year}</option>
        ))}
      </select>
    </div>
  );
}
